import { FC, PropsWithChildren, ReactNode } from 'react';
import { NavItem } from './types';
import { Box, IconButton } from '@chakra-ui/react';
import { LuBox } from 'react-icons/lu';
import { Tooltip as ChakraTooltip } from '@mono/chakra';
import { NavMenu } from './NavMenu';

const Tooltip: FC<PropsWithChildren<{ label: ReactNode }>> = ({
  children,
  label,
}) => {
  return (
    <ChakraTooltip
      showArrow
      content={label}
      openDelay={100}
      closeDelay={100}
      positioning={{
        placement: 'right-end',
        offset: { mainAxis: 16, crossAxis: -10 },
      }}
    >
      {children}
    </ChakraTooltip>
  );
};

const Navigation: FC<{
  items: NavItem[];
  onClickNavItem?: (path: string) => void;
}> = ({ items, onClickNavItem }) => {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      gap={2}
      p={1}
      alignItems={'center'}
    >
      {items.map((item, index) => {
        return (
          <Tooltip label={item.label} key={index}>
            {item.path ? (
              <IconButton
                as={'a'}
                size={'lg'}
                variant={{
                  _dark: 'surface',
                  _light: 'solid',
                }}
                onClick={() => {
                  onClickNavItem?.(item.path);
                }}
              >
                {item.icon ?? <LuBox />}
              </IconButton>
            ) : (
              <div>
                <NavMenu content={item.children}>
                  <IconButton
                    as={'a'}
                    size={'lg'}
                    variant={{
                      _dark: 'surface',
                      _light: 'solid',
                    }}
                  >
                    {item.icon ?? <LuBox />}
                  </IconButton>
                </NavMenu>
              </div>
            )}
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default Navigation;
